import { DynamicRow } from "./dynamic-row.model";

export class DynamicRowItem<T> extends DynamicRow<T> {

    data?: T;
    property!: keyof T;
    formGroupIndex?: number = -1;

    constructor(source: Partial<DynamicRowItem<T>>) {
        super(source);
        this.type = "item";
        Object.assign(this, source);
    }
}